import React from 'react';
import { UserResultRow } from "./UserResultRow";

const TagColumns = (props: any) => {

    const row : UserResultRow = props.row;
    const tagList : string[] = props.tagList;

    let c = 1;

    return <>
               { tagList.map(tag =>
                   <td key={c++}>{row.getPoints(tag)}</td>) }
           </>
};

export default TagColumns;
